import { AuthenticationOption } from '../../../connectivity/services/credentialsClient';
import { VerificationExtended } from '../../models/verification';

export enum TransferStatus {
  CANCELLED = 'CANCELLED',
  CREATED = 'CREATED', // direct payment's transfer first has a status of CREATED after the /execute call
  AWAITING_CREDENTIALS = 'AWAITING_CREDENTIALS',
  FAILED = 'FAILED',
  SETTLED = 'SETTLED',
  SETTLED_PAYER = 'SETTLED_PAYER',
  SETTLED_PAYEE = 'SETTLED_PAYEE',
  SENT = 'SENT',
}

export enum InternalStatus {
  DUPLICATE_PAYMENT = 'DUPLICATE_PAYMENT',
  BANKID_NEEDS_EXTENDED_USE_ENABLED = 'BANKID_NEEDS_EXTENDED_USE_ENABLED',
}

export type TransfersEntity = {
  destinationUri: string;
  id: string;
  sourceUri: string;
  status: TransferStatus;
  internalStatus: InternalStatus | string | null;
  statusMessage?: string;
} & VerificationExtended;

export type CreateTransferRequest = {
  credentialsId: string;
  requestId: string;
  redirectUri?: string;
  sourceUri?: string;
  selectedProvider: string;
  selectedAuthenticationOptions?: AuthenticationOption[];
};

export const Transfer = {
  isCreated: (transfer?: TransfersEntity): boolean => {
    return transfer ? transfer.status === TransferStatus.CREATED : false;
  },
  isCancelled: (transfer?: TransfersEntity): boolean => {
    return transfer ? transfer.status === TransferStatus.CANCELLED : false;
  },
  isSent: (transfer?: TransfersEntity): boolean => {
    return transfer
      ? transfer.status === TransferStatus.SENT ||
          transfer.status === TransferStatus.SETTLED ||
          transfer.status === TransferStatus.SETTLED_PAYEE ||
          transfer.status === TransferStatus.SETTLED_PAYER
      : false;
  },
  isFailed: (transfer?: TransfersEntity): boolean => {
    return transfer ? transfer.status === TransferStatus.FAILED : false;
  },
  isAwaiting: (transfer?: TransfersEntity): boolean => {
    return transfer ? transfer.status === TransferStatus.AWAITING_CREDENTIALS : false;
  },
  isCompleted: <T extends Pick<TransfersEntity, 'status'>>(transfer?: T): boolean => {
    return transfer
      ? transfer.status === TransferStatus.SENT ||
          transfer.status === TransferStatus.SETTLED_PAYEE ||
          transfer.status === TransferStatus.SETTLED_PAYER ||
          transfer.status === TransferStatus.FAILED ||
          transfer.status === TransferStatus.SETTLED ||
          transfer.status === TransferStatus.CANCELLED
      : false;
  },
  hasInternalStatusDuplicatePayment: (transfer?: TransfersEntity): boolean => {
    return transfer ? transfer.internalStatus === InternalStatus.DUPLICATE_PAYMENT : false;
  },
  hasInternalStatusNeedsExtendedBankId: (transfer?: TransfersEntity): boolean => {
    return transfer
      ? transfer.internalStatus === InternalStatus.BANKID_NEEDS_EXTENDED_USE_ENABLED
      : false;
  },
  isValidTransferObject: (data: Partial<TransfersEntity>): data is TransfersEntity =>
    Boolean(data?.id),
};
